module.exports = __webpack_public_path__ + "static/media/sysadmin_default.ab3e530a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/satuan/sysadmin_default.svg
// module id = 529
// module chunks = 14